import type { GetSelectOptions } from './types'

export const getSelectOptions = ({ options, t }: GetSelectOptions) =>
  Object.entries(options).map(([key, value], index) => ({
    id: index,
    label: t(value),
    value: index,
    key,
  }))
